import { traverseNode, isTag } from 'anodum';
import isBlockElement from '../verifiers/is-block-element';

const findFirstBlockElement = (element) => {
  let blockElement = null;
  traverseNode(element, (node) => {
    if (isBlockElement(node) && !blockElement && !isTag(node, 'body')) {
      blockElement = node;
    }
  });
  return blockElement;
};

export default findFirstBlockElement;
